export default "__VITE_ASSET__D1DeIeRJ__"